// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__35mb3","footer":"ChangeClinic_footer__9mD30"};